import React from "react";
import { SEGMENT_BZA, SEGMENT_BZA_ID, SEGMENT_CMC, SEGMENT_CMC_ID } from "../constants";
import SegmentedProductPage from "../SegmentedProductPage";
import CommercialOperatorNews from "./CommercialOperatorNews";
import BusinessOperatorNews from "./BusinessOperatorNews";
import { productPageProps } from "../../common/types/product";

export default function OperatorNews({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<SegmentedProductPage
			tabsDefinition={[
				{
					id: SEGMENT_CMC_ID,
					title: `${SEGMENT_CMC} Operator News`,
					renderContent: (tabsNav) => (
						<CommercialOperatorNews
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
				{
					id: SEGMENT_BZA_ID,
					title: `${SEGMENT_BZA} Operator News`,
					renderContent: (tabsNav) => (
						<BusinessOperatorNews
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
			]}
		/>
	);
}
